import { render, staticRenderFns } from "./productDownDetail.vue?vue&type=template&id=07300171&scoped=true"
import script from "./productDownDetail.vue?vue&type=script&lang=js"
export * from "./productDownDetail.vue?vue&type=script&lang=js"
import style0 from "./productDownDetail.vue?vue&type=style&index=0&id=07300171&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07300171",
  null
  
)

export default component.exports